module.exports = "/images/buildings.svg";